import type { QuestionView } from "./assistant-types";

/** What support-bot answers for a Conversation it no longer holds: after a restart, or a day idle. */
const CONVERSATION_GONE = 404;

export interface ConversationCalls {
  start: () => Promise<string>;
  ask: (conversationId: string) => Promise<QuestionView>;
}

/** Asks in the current Conversation, starting one when there is none, or once more in a new one when it is gone. */
export async function askInConversation(
  current: string | undefined,
  calls: ConversationCalls,
): Promise<{ conversationId: string; settled: QuestionView }> {
  if (current === undefined) return askIn(await calls.start(), calls);
  try {
    return await askIn(current, calls);
  } catch (error) {
    if (!isConversationGone(error)) throw error;
    return askIn(await calls.start(), calls);
  }
}

async function askIn(conversationId: string, calls: ConversationCalls) {
  return { conversationId, settled: await calls.ask(conversationId) };
}

function isConversationGone(error: unknown): boolean {
  return (error as { status?: unknown }).status === CONVERSATION_GONE;
}
